import React,{useState,useEffect,useRef} from 'react'
import styled from 'styled-components'

const SearchBar = () => {
    const [openBar,setOpenBar] = useState(false)
    const inputRef = useRef(null)

    useEffect(()=>{
        if(openBar){
            inputRef.current.focus()
        }
    },[openBar])

    return (
        <Wrapper>
            <div className={openBar ? 'search active':'search'}>
               {openBar && <input type='text' placeholder='search here...' className='input' ref={inputRef} />} 
                <div className="search-btn" onClick={()=>setOpenBar(!openBar)}>
                    <i className="fas fa-search"></i>
                </div>
                
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.section`

    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin: 0;

    .search{
        position: relative;
        height: 35px;
    }
    .search .input{
        background-color: #fff;
        border: 0;
        font-size: 18px;
        padding: 15px;
        height: 30px;
        width: 0;
        transition: var(--transition);
        border-radius: 20px;
    }

    .search-btn{
        border-radius: 20px;
        background-color: #fff;
        border: 0;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        height: 30px;
        width: 50px;
        transition: transform 0.4s ease;
        color: var(--clr-black);
        
    }

    .search-btn .fas{
        transform: translate(16px,4px);
    }

    .search-btn:focus, .input:focus{
        outline: none;
    }

    .search.active .input{
        width: 250px;
    }

    .search.active .search-btn{
        transform: translateX(198px);
    }
`

export default SearchBar
